import React from 'react';
import HeroSection from '../components/home/HeroSection';
import FeatureSection from '../components/home/FeatureSection';
import TeacherSection from '../components/home/TeacherSection';

import ContactSection from '../components/home/ContactSection';
import PromotionBanner from '../components/home/PromotionBanner';
import TestimonialsSection from '../components/home/TestimonialsSection';
import LearningMaterialsSection from '../components/home/LearningMaterialsSection';
import Footer from '../components/layout/Footer';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollToContact) {
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }

      // Xoá state sau khi scroll để tránh F5 vẫn scroll lại
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  return (
    <div>
      <main className="pt-16"> {/* pt-16 to account for fixed navbar */}
        <HeroSection />
        <PromotionBanner />
        <FeatureSection />
        <TeacherSection />
        <TestimonialsSection />
        <LearningMaterialsSection />
        {/* <NewsSection /> */}
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
